<py-notification *ngIf="isDeliveryUnknown" type="info" [tiny]="true">{{
  'trackAndTrace.orderStatusUnknown_message' | cxTranslate
}}</py-notification>
<ul class="timeline">
  <li>
    <div class="indicator first active my-2" [class.highlighted]="!hasOrderProcessingStarted"></div>
    <div class="d-flex flex-row flex-md-column details">
      <i nz-icon nzType="shopping-cart" nzTheme="outline"></i>
      <div class="d-flex flex-column pl-3 pl-md-0">
        <div class="details-label">{{ 'trackAndTrace.orderStatus_received_badge' | cxTranslate }}</div>
        <div class="description" *ngIf="!isDeliveryUnknown">{{ delivery.orderCreatedDate | cxDate: 'dateTime' }}</div>
      </div>
    </div>
  </li>
  <li [class.disabled]="isDeliveryUnknown">
    <div
      class="indicator my-2"
      [class.active]="hasOrderProcessingStarted"
      [class.highlighted]="hasOrderProcessingStarted && !hasTransitStarted"
    ></div>
    <div class="d-flex flex-row flex-md-column details">
      <i nz-icon nzType="box-closed" nzTheme="outline"></i>
      <div class="d-flex flex-column pl-3 pl-md-0">
        <div class="details-label">{{ 'trackAndTrace.orderStatus_leftWarehouse_badge' | cxTranslate }}</div>
        <div class="description" *ngIf="hasOrderProcessingStarted && isOrderProcessingComplete">
          {{ delivery.overallPickingStatusDate | cxDate: 'dateTime' }}
        </div>
      </div>
    </div>
  </li>
  <li [class.disabled]="isDeliveryUnknown">
    <div
      class="indicator my-2"
      [class.active]="hasTransitStarted"
      [class.highlighted]="hasTransitStarted && !isDeliveryComplete"
    ></div>
    <div class="d-flex flex-row flex-md-column details">
      <i nz-icon nzType="delivery-truck" nzTheme="outline"></i>
      <div class="d-flex flex-column pl-3 pl-md-0">
        <div class="details-label">{{ 'trackAndTrace.orderStatus_inTransit_badge' | cxTranslate }}</div>
        <div class="description" *ngIf="hasTransitStarted && isTransitComplete">
          {{ delivery.transitStatusDate || delivery.totalGoodsMovementStatusDate | cxDate: 'dateTime' }}
        </div>
      </div>
    </div>
  </li>
  <li [class.disabled]="isDeliveryUnknown">
    <div class="indicator my-2" [class.active]="isDeliveryComplete" [class.highlighted]="isDeliveryComplete"></div>
    <div class="d-flex flex-row flex-md-column details">
      <i nz-icon nzType="home" nzTheme="outline"></i>
      <div class="d-flex flex-column pl-3 pl-md-0">
        <div class="details-label">{{ 'trackAndTrace.orderStatus_delivered_badge' | cxTranslate }}</div>
        <div class="description" *ngIf="hasDeliveryStarted && isDeliveryComplete">
          {{ delivery.deliveryStatusDate | cxDate: 'dateTime' }}
        </div>
      </div>
    </div>
  </li>
</ul>

<div
  class="tracking-number-wrapper d-flex flex-column flex-sm-row align-items-baseline border-top py-4"
  *ngIf="showTrackingLinks && delivery?.handlingUnits?.length > 0"
>
  <span class="tracking-number-title">
    {{ 'orderHistory.trackingNumber_hint' | cxTranslate }}
  </span>
  <div class="d-flex flex-column flex-sm-row flex-wrap align-items-center">
    <ng-container *ngFor="let handlingUnit of delivery.handlingUnits">
      <button
        class="tracking-number-item ml-2 my-1 py-1 px-3"
        [disabled]="!handlingUnit?.trackingUrl"
        (click)="navigateToExternalTrackingPage(handlingUnit?.trackingUrl)"
      >
        {{ handlingUnit?.trackingNumber }}
        <i class="ml-1" nz-icon nzType="export"></i>
      </button>
    </ng-container>
  </div>
</div>
